module.exports = __webpack_public_path__ + "static/media/loading1.79f801ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading1.png
// module id = 77
// module chunks = 0